import { useEffect } from "react";

function usePageMeta(title, description) {
  useEffect(() => {
    // Update the document title
    document.title = title;

    // Find the meta description tag, or create it if it doesn't exist
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.setAttribute("name", "description");
      document.head.appendChild(metaDescription);
    }

    // Update the meta description content
    metaDescription.setAttribute("content", description);
  }, [title, description]); // Re-run effect if title or description changes
}

export default usePageMeta;
